/**
 * Every EHR sync domain the UI knows how to render a button for.
 *
 * This is the union across all vendors, not the list for any one of them:
 * Athena has no `demographics` or `vitals`, eCW has no `cases`, and a new
 * vendor may return something else again. Which of these actually get a button
 * is decided at runtime from the capabilities response, never from this list.
 */
export const EhrDomains = {
  ALL: "all",
  DEMOGRAPHICS: "demographics",
  INSURANCE: "insurance",
  CONDITIONS: "conditions",
  ALLERGIES: "allergies",
  IMMUNIZATIONS: "immunizations",
  MEDICATIONS: "medications",
  DOCUMENTS: "documents",
  LAB_RESULTS: "lab-results",
  VITALS: "vitals",
  CASES: "cases",
} as const;
